import { selectIsUserAgent } from '../../../packages/Filters/shared/selectors';
import { IAppState } from '../../common/state';
import { MORTGAGE_PROMO_DISCOUNT_CAMPAIGN } from '../../constants/experiments';
import { dealTypeFromJsonQuery, FDealType, FOfferType, offerTypeFromJsonQuery } from '../../utils/category';

export const selectIsAlfaSecondaryMortgagePromoVisible = (state: IAppState) => {
  const { featureToggle, abUseExperiments } = state;
  const { isAlfaSecondaryMortgagePromoBannerRandomRotationEnabled } = featureToggle;

  const experiment = abUseExperiments.find(e => e.experimentName === MORTGAGE_PROMO_DISCOUNT_CAMPAIGN);
  const isActiveExperiment = experiment !== undefined && experiment.groupName === 'B';

  if (!isActiveExperiment) {
    return false;
  }

  if (!isAlfaSecondaryMortgagePromoBannerRandomRotationEnabled) {
    return false;
  }

  const isAgent = selectIsUserAgent(state);

  if (isAgent) {
    return false;
  }

  const { jsonQuery } = state.filters;
  const dealType = dealTypeFromJsonQuery(jsonQuery);

  if (dealType !== FDealType.Sale) {
    return false;
  }

  const offerType = offerTypeFromJsonQuery(jsonQuery);

  return offerType === FOfferType.Flat || offerType === FOfferType.FlatOld;
};
